"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var expressions_1 = require("../../types/expressions");
var jsonschema_1 = require("../../utils/jsonschema");
var schema = {
    $id: jsonschema_1.$id('variableExpression'),
    title: expressions_1.ResolvedExpressionType.Variable,
    type: 'object',
    properties: {
        $expression: {
            type: 'string',
            enum: [expressions_1.ResolvedExpressionType.Variable]
        },
        query: {
            $ref: jsonschema_1.$id('stringExpression')
        },
        deepCopy: {
            type: 'boolean',
            nullable: true
        }
    },
    additionalProperties: false,
    required: ['$expression', 'query']
};
exports.default = schema;
//# sourceMappingURL=variable.schema.js.map